"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bluebird_1 = __importDefault(require("bluebird"));
exports.promiseWhile = (condition, action, initialValue) => {
    return bluebird_1.default.method(async function fn(_condition, _action, _initialValue) {
        const value = await _action(_initialValue);
        if (!_condition(value))
            return value;
        return fn(_condition, _action, value);
    })(condition, action, initialValue);
};
//# sourceMappingURL=promiseWhile.js.map